import { useEffect } from 'react';

const SITE_URL = 'https://jepprep.com';

export function useSEO(title, description, options = {}) {
  const { canonical, ogImage, noindex } = options;

  useEffect(() => {
    const prev = document.title;
    document.title = title;

    const meta = document.querySelector('meta[name="description"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogImg = document.querySelector('meta[property="og:image"]');
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    const twImg = document.querySelector('meta[name="twitter:image"]');
    const robotsMeta = document.querySelector('meta[name="robots"]');

    const prevDesc = meta?.getAttribute('content');
    const prevOgUrl = ogUrl?.getAttribute('content');
    const prevOgImg = ogImg?.getAttribute('content');
    const prevRobots = robotsMeta?.getAttribute('content');

    if (meta && description) meta.setAttribute('content', description);
    if (ogTitle) ogTitle.setAttribute('content', title);
    if (ogDesc && description) ogDesc.setAttribute('content', description);
    if (twTitle) twTitle.setAttribute('content', title);
    if (twDesc && description) twDesc.setAttribute('content', description);

    // Set og:url per page
    const pageUrl = canonical || `${SITE_URL}${window.location.pathname}`;
    if (ogUrl) ogUrl.setAttribute('content', pageUrl);

    // Set og:image if provided
    if (ogImage && ogImg) ogImg.setAttribute('content', ogImage);
    if (ogImage && twImg) twImg.setAttribute('content', ogImage);

    // Handle canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalLink?.getAttribute('href');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', pageUrl);
    }

    // Handle noindex
    if (noindex && robotsMeta) {
      robotsMeta.setAttribute('content', 'noindex, nofollow');
    }

    return () => {
      document.title = prev;
      if (meta && prevDesc) meta.setAttribute('content', prevDesc);
      if (ogUrl && prevOgUrl) ogUrl.setAttribute('content', prevOgUrl);
      if (ogImg && prevOgImg) ogImg.setAttribute('content', prevOgImg);
      if (canonicalLink && prevCanonical) canonicalLink.setAttribute('href', prevCanonical);
      if (robotsMeta && prevRobots) robotsMeta.setAttribute('content', prevRobots);
    };
  }, [title, description, canonical, ogImage, noindex]);
}
